import React from "react";
import WebModalForm from "../forms/webmodalform";

const WebModal = ({ modal, toggleModal, customHeading  }) => {
  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  return (
    <>
      {modal && (
        <div className="modal">
          <div onClick={toggleModal} className="overlay" />
          <div className="modal-content">
            <button className="absolute top-[-14px] right-[-10px] w-[45px] z-[2]" onClick={toggleModal}>
              <img src="https://glocify.com/images/cross-icon.png" alt="cross-icon" />
            </button>
            <div className="lg:grid grid-cols-2">
              <div className="bg-[linear-gradient(138deg,#F16500_-6.96%,#FF9A3E_96.93%)] lg:rounded-l-[32px]  lg:px-[50px] px-4 modal-background relative">
                <div className="z-10">
                {customHeading === "limitedTimeOffer" ? (
                    <>
                      <h2 className="lg:text-[55px] text-[20px] text-center text-white font-semibold lg:leading-[1.1] lg:pt-[35px] py-4">
                        LIMITED TIME OFFER!
                      </h2>
                      <p className="text-lg font-normal pt-[10px] text-white text-center lg:block hidden">
                        Consult Now!
                      </p>
                    </>
                  ) : (
                    <>
                      <h2 className="lg:text-[36px] text-[20px] text-white font-semibold lg:leading-[40px] leading-[26px] lg:pt-[35px] py-4">
                      Hire Stripe Expert Today!
                      </h2>
                      <p className="text-base font-normal pt-[0px] text-white lg:block hidden">
                      Connect with expert developers to streamline your Stripe integration and grow your business efficiently
                      </p>
                    </>
                  )}
                  <div className="max-w-[340px] absolute bottom-[-1px] z-[2] lg:block hidden">
                    <img src="https://glocify.com/images/hand-phone.png" alt="hand-phone" />
                  </div>
                </div>
              </div>
              <div className="lg:p-[50px] p-6 bg-white rounded-r-[32px]">                
                <WebModalForm formId={customHeading === "limitedTimeOffer" ? 16808 : 16704} formSubject={customHeading === "limitedTimeOffer" ? "Hire Stripe Dev Pop-Up Form Query" : "Hire Stripe Dev Pop-Up Form Query"} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WebModal;

